import React, { useReducer, useState } from 'react';
import CurriculumContext from './curriculumContext';
import CurriculumReducer from './curriculumReducer';
import api from '../../../api';

import { TYPES } from '../../types';

const CurriculumState = (props) => {

    const initialState = {
        banner: null,
        description: null,
        subjects: null,
        evaluation: null,
        ibBachelor: null,
        profile: null,
        educativeModel: null,
        activities: null
    }


    const [dotsLoaded, setDotsLoaded] = useState(false);

    const [state, dispatch] = useReducer(CurriculumReducer, initialState);

    const [studentProfileState,
        setStudentProfileState] = useState({
            enter: false,
            active: false
        });
    const [academicAreasState,
        setAcademicAreasState] = useState({
            enter: false,
            active: false
        });
    const [alliesState,
        setAlliesState] = useState({
            enter: false,
            active: false
        });
    const [toolsState,
        setToolsState] = useState({
            enter: false,
            active: false
        });
    const [cocurricularState,
        setCocurricularState] = useState({
            enter: false,
            active: false
        });
    const [blankState, setBlankState] = useState({
        enter: false,
        active: true
    });

    //FETCH ALL CURRICULUM PAGE DATA FROM API
    const getCurriculum = async () => {
        try {
            const result = await api.get('/curriculum');
            dispatch({
                type: TYPES.GET_CURRICULUM,
                payload: result.data
            })
        } catch (error) {

        }
    }

    return (
        <CurriculumContext.Provider
            value={{
                banner: state.banner,
                description: state.description,
                subjects: state.subjects,
                evaluation: state.evaluation,
                ibBachelor: state.ibBachelor,
                profile: state.profile,
                educativeModel: state.educativeModel,
                activities: state.activities,
                dotsLoaded,
                setDotsLoaded,
                getCurriculum,
                studentProfileState,
                setStudentProfileState,
                academicAreasState,
                setAcademicAreasState,
                alliesState,
                setAlliesState,
                toolsState,
                setToolsState,
                cocurricularState,
                setCocurricularState,
                blankState,
                setBlankState
            }}
        >
            {props.children}
        </CurriculumContext.Provider>
    )

}

export default CurriculumState;